// Debug flag
const DEBUG = true;

// Debug logging helper
function debug(...args) {
  if (DEBUG) {
    console.log('[ProductCard Debug]:', ...args);
  }
}

debug('Script loaded and running');

class ProductCard {
  constructor(element) {
    debug('Initializing ProductCard for element:', element);
    
    this.element = element;
    this.form = element.querySelector('form');
    
    if (!this.form) {
      debug('No form found in element:', element);
      return;
    }
    
    const productJson = this.form.querySelector('[data-product-json]');
    debug('Product JSON element:', productJson?.outerHTML);
    
    if (!productJson) {
      debug('No product JSON element found');
      return;
    }
    
    try {
      this.productData = JSON.parse(productJson.textContent);
      debug('Parsed product data:', {
        id: this.productData.id,
        title: this.productData.title,
        variants: this.productData.variants?.length,
        selectedVariant: this.productData.selected_or_first_available_variant,
        sellingPlanGroups: this.productData.selling_plan_groups,
        sellingPlanAllocations: this.productData.selling_plan_allocations
      });
    } catch (error) {
      debug('Error parsing product JSON:', error);
      console.error('Product JSON parsing error:', error);
      debug('Raw JSON content:', productJson.textContent);
      return;
    }
    this.initializeElements();
    this.attachEventListeners();

    // Track current variant and subscription state
    this.currentVariant = this.productData.selected_or_first_available_variant;
    debug('Current variant:', {
      id: this.currentVariant.id,
      title: this.currentVariant.title,
      sellingPlanAllocations: this.currentVariant.selling_plan_allocations
    });
    this.isSubscriptionMode = false;
    this.selectedIntervalWeeks = null; // Track selected interval

    // Check if subscription is initially selected
    const subscribeRadio = this.form.querySelector('input[name^="delivery_option--"][value="subscribe"]:checked');
    if (subscribeRadio) {
      debug('Subscription initially selected');
      this.isSubscriptionMode = true;
      // Ensure we select the first interval option
      this.selectFirstInterval();
    }

    // Initialize with current variant
    if (this.currentVariant) {
      this.updateSubscriptionUI(this.currentVariant, this.isSubscriptionMode);
    }
  }

  initializeElements() {
    // Cache DOM elements
    this.variantIdInput = this.form.querySelector('[data-variant-id]');
    this.subscriptionInput = this.form.querySelector('[data-subscription-input]');
    this.intervalsContainer = this.form.querySelector('.subscription-intervals');
    this.intervalSelector = this.form.querySelector('[js-interval-selector]');
    this.purchaseOptions = this.form.querySelector('[data-purchase-options]');
    this.oneTimePriceDisplayEl = this.form.querySelector('[data-one-time-price-display]');
    this.subscriptionPriceDisplayEl = this.form.querySelector('[data-subscription-price-display]');
    this.subscriptionComparePriceDisplayEl = this.form.querySelector('[data-subscription-compare-price-display]');
    this.subscriptionTextEl = this.form.querySelector('[data-subscription-text]');
    this.desktopButton = this.element.querySelector('[js-show-real-button]')
    this.mobileButton = this.element.querySelector('[js-show-real-button-mobile]')
    this.fakeBisButtons = this.element.querySelectorAll('[js-click-klaviyo]');
    this.everyAtcSection = document.querySelectorAll('[js-product-card-buttons]')
    var that = this;

    if(this.fakeBisButtons) {
      this.fakeBisButtons.forEach((button) => {
        button.addEventListener('click', (evt) => {
          evt.preventDefault();
          const fakeButton = evt.currentTarget;
          const realButton = this.element.querySelector('.back-in-stock-button-clickable')
  
        this.everyAtcSection.forEach((section) => {
          const fakeATC = section.querySelector('[js-show-real-button]');
          const sectionToShow = section.querySelector('[js-show-real-section]');

          if(!sectionToShow.classList.contains('tw-hidden')) {
            sectionToShow.classList.add('tw-hidden');
          }
          if(sectionToShow.classList.contains('focused')) {
            sectionToShow.classList.remove('focused');
          }

          if(fakeATC) {
            if(fakeATC.classList.contains('tw-absolute')) {
              fakeATC.classList.remove('tw-absolute');
              fakeATC.classList.remove('tw-opacity-0');
              fakeATC.classList.remove('no-pointer');
            }
          }

        })


          realButton.click();
        })
      })
    }


    if(this.desktopButton) {
      this.desktopButton.addEventListener('click', (evt) => {
        evt.preventDefault();
        const fakeButton = evt.currentTarget
        const sectionToShow = this.element.querySelector('[js-show-real-section]');

        this.everyAtcSection.forEach((section) => {
          const fakeATC = section.querySelector('[js-show-real-button]');
          const sectionToShow = section.querySelector('[js-show-real-section]');

          if(!sectionToShow.classList.contains('tw-hidden')) {
            sectionToShow.classList.add('tw-hidden');
          }
          if(sectionToShow.classList.contains('focused')) {
            sectionToShow.classList.remove('focused');
          }

          if(fakeATC) {
            if(fakeATC.classList.contains('tw-absolute')) {
              fakeATC.classList.remove('tw-absolute');
              fakeATC.classList.remove('tw-opacity-0');
              fakeATC.classList.remove('no-pointer');
            }
          }

        })

          if(sectionToShow.classList.contains('tw-hidden')) {
            sectionToShow.classList.remove('tw-hidden');
            sectionToShow.classList.add('focused');
            fakeButton.classList.add('tw-absolute');
            fakeButton.classList.add('tw-opacity-0');
            fakeButton.classList.add('no-pointer');
          }

      })
    }

    if(this.mobileButton) {
      this.mobileButton.addEventListener('click', (evt) => {
        evt.preventDefault();
        const sectionToMove = this.element.querySelector('[js-product-card-buttons]');
        const sectionToShow = this.element.querySelector('[js-show-real-section]');
        const sectionHeightSection = this.element.querySelector('[js-grab-height]');
        const sectionHeight = sectionHeightSection.clientHeight + 24;

        this.everyAtcSection.forEach((section) => {
          const sectionToShow = section.querySelector('[js-show-real-section]');

          if(!sectionToShow.classList.contains('tw-hidden')) {
            sectionToShow.classList.add('tw-hidden');
          }
          if(sectionToShow.classList.contains('focused')) {
            sectionToShow.classList.remove('focused');
          }

        })

        if(sectionToShow.classList.contains('tw-hidden')) {
          sectionToShow.classList.remove('tw-hidden');
          sectionToShow.classList.add('focused');
          sectionToMove.style.bottom = `-${sectionHeight}px`
        }
      })
    }

    // If the user clicks outside of any product card, hide all .focused js-show-real-section elements
    document.addEventListener('click', (evt) => {
      // Find if click is inside any product card
      const productCard = evt.target.closest('.product-card--seed');
      if (!productCard) {
        // Click is outside of any product card
        document.querySelectorAll('[js-show-real-section].focused').forEach((sectionToShow) => {
          sectionToShow.classList.remove('focused');
          sectionToShow.classList.add('tw-hidden');
        });
      }
    })
    
    debug('Found elements:', {
      variantIdInput: this.variantIdInput,
      subscriptionInput: this.subscriptionInput,
      intervalsContainer: this.intervalsContainer,
      purchaseOptions: this.purchaseOptions,
      oneTimePriceDisplayEl: this.oneTimePriceDisplayEl,
      subscriptionPriceDisplayEl: this.subscriptionPriceDisplayEl,
      subscriptionComparePriceDisplayEl: this.subscriptionComparePriceDisplayEl,
      subscriptionTextEl: this.subscriptionTextEl
    });
  }

  selectFirstInterval() {
    const firstInterval = this.form.querySelector('.interval-option')
    const selector = this.form.querySelector('[js-interval-selector]')
    const intervalSelector = this.form.querySelector('.interval-select-option')


    if (firstInterval) {
      debug('Selecting first interval')
      // Directly update styles and trigger selection
      
      // Store selected interval weeks
      this.selectedIntervalWeeks = firstInterval.dataset.weeks;
      
      // Update subscription input
      if (this.subscriptionInput) {
        this.subscriptionInput.value = firstInterval.dataset.planId;
      }
    }

    if(intervalSelector) {
      //reset selector 
      selector.selectedIndex = 0;

      // Store selected interval weeks
      this.selectedIntervalWeeks = intervalSelector.dataset.weeks;
      
      // Update subscription input
      if (this.subscriptionInput) {
        this.subscriptionInput.value = intervalSelector.dataset.planId;
      }
    }

  }

  selectIntervalByWeeks(weeks) {
    const intervalButton = this.form.querySelector(`.interval-option[data-weeks="${weeks}"]`);
    if (intervalButton) {
      debug('Selecting interval by weeks:', weeks);
      // Update styles
      
      // Store selected interval weeks
      this.selectedIntervalWeeks = weeks;
      
      // Update subscription input
      if (this.subscriptionInput) {
        this.subscriptionInput.value = intervalButton.dataset.planId;
      }

      // Update pricing
    //   const price = parseFloat(intervalButton.dataset.price);
    //   const comparePrice = parseFloat(intervalButton.dataset.comparePrice);
    //   const subscriptionPrice = parseFloat(intervalButton.dataset.subscriptionPrice || price);
    //   const subscriptionComparePrice = parseFloat(intervalButton.dataset.subscriptionComparePrice || comparePrice);
    //   this.updateIntervalPricing(subscriptionPrice, subscriptionComparePrice);
      
      return true;
    }
    return false;
  }

  findAllocationByWeeks(allocations, weeks) {
    debug('Finding allocation for weeks:', weeks);
    debug('Available allocations:', JSON.stringify(allocations, null, 2));
    
    if (!allocations || !Array.isArray(allocations)) {
      debug('No valid allocations provided');
      return null;
    }

    return allocations.find(allocation => {
      debug('Checking allocation:', allocation);
      
      // Handle case where selling_plan might be undefined
      if (!allocation || !allocation.selling_plan) {
        debug('Invalid allocation structure:', allocation);
        return false;
      }

      try {
        const planName = allocation.selling_plan.name || '';
        debug('Plan name:', planName);
        const planWeeks = planName.replace('Delivery every', '').replace('Weeks', '').trim();
        debug('Extracted weeks:', planWeeks);
        return planWeeks === weeks;
      } catch (error) {
        console.error('Error processing allocation:', error);
        return false;
      }
    });
  }

  attachEventListeners() {
    // Variant selection - listen to all input changes and filter
    this.form.addEventListener('change', (e) => {
      debug('Form change event:', e.target);
      
      // Handle variant selection
      if (e.target.closest('[data-snippet="product-options"]') && e.target.matches('input[type="radio"]')) {
        debug('Variant changed:', e.target.value);
        this.handleVariantChange(e.target);
      }
      
      // Handle delivery option selection
      if (e.target.matches('input[name^="delivery_option--"]')) {
        debug('Delivery option changed:', e.target.value);
        this.handleDeliveryOptionChange(e.target);
      }
    });

    this.form.addEventListener('submit', () => {
      const eachCardButtons = document.querySelectorAll('[js-product-card-buttons]')
      
      eachCardButtons.forEach((section) => {
        const fakeButton = section.querySelector('[js-show-real-button]');
        const realSection = section.querySelector('[js-show-real-section]');


        if(fakeButton) {
          if(fakeButton.classList.contains('tw-absolute')) {
            fakeButton.classList.remove('tw-absolute');
            fakeButton.classList.remove('tw-opacity-0');
            fakeButton.classList.remove('no-pointer');
          }
        }

        if(!realSection.classList.contains('tw-hidden')) {
          realSection.classList.add('tw-hidden');
          realSection.style.bottom = '0px'
        }
      })


    })

    // Interval selection (using event delegation)
    if (this.intervalsContainer) {
      this.intervalsContainer.addEventListener('click', (e) => {
        if (e.target.matches('.interval-option')) {
          this.handleIntervalSelection(e.target);
        }
      });
      if(this.intervalSelector) {
        this.intervalSelector.addEventListener('change', (e) => {
          this.handleIntervalSelector(e.target.options[this.intervalSelector.selectedIndex]);
        })
      }
    }
  }

  handleVariantChange(variantInput) {
    debug('Variant change triggered for:', variantInput.value);
    
    // Get the variant directly by size value
    const variant = this.productData.variants.find(v => 
      v.option1 === variantInput.value || 
      v.option2 === variantInput.value || 
      v.option3 === variantInput.value
    );
    
    debug('Found variant:', variant);
    debug('Current subscription mode:', this.isSubscriptionMode);
    
    if (!variant) {
      debug('No variant found');
      return;
    }

    // Update current variant
    this.currentVariant = variant;

    // Update variant ID and one-time price
    this.variantIdInput.value = variant.id;
    
    if (this.oneTimePriceDisplayEl) {
      debug('Updating one-time price:', variant.price);
      // Update both data attribute and display price
      this.oneTimePriceDisplayEl.dataset.price = variant.price;
      this.oneTimePriceDisplayEl.textContent = this.formatMoney(variant.price);
    }
    if (this.subscriptionPriceDisplayEl) {
      const subscriptionPrice = parseFloat(variantInput.dataset.subscriptionPrice);
      debug('Updating subscription price:', subscriptionPrice);
      this.subscriptionPriceDisplayEl.dataset.price = subscriptionPrice;
      this.subscriptionPriceDisplayEl.textContent = this.formatMoney(subscriptionPrice);
    }

    // First update all interval buttons with the new variant's allocation data
    const intervalButtons = this.form.querySelectorAll('.interval-option');
    intervalButtons.forEach(button => {
      const weeks = button.dataset.weeks;
      const allocation = this.findAllocationByWeeks(variant.selling_plan_allocations, weeks);
      if (allocation) {
        debug('Updating interval button data:', {
          weeks,
          price: allocation.price,
          comparePrice: allocation.compare_at_price || variant.price
        });
        button.dataset.price = allocation.price;
        button.dataset.comparePrice = allocation.compare_at_price || variant.price;
        button.dataset.planId = allocation.selling_plan.id;
      }
    });

    const intervalSelector = this.form.querySelector('.interval-select-option')
    const selector = this.form.querySelector('[js-interval-selector]')

    if(intervalSelector) {
       //reset selector 
      selector.selectedIndex = 0;
      
      // Store selected interval weeks
      this.selectedIntervalWeeks = intervalSelector.dataset.weeks;
      
      // Update subscription input
      if (this.subscriptionInput) {
        this.subscriptionInput.value = intervalSelector.dataset.planId;
      }
    }

    // Always update subscription UI with current subscription mode state
    this.updateSubscriptionUI(variant, this.isSubscriptionMode);
  }

  updateSubscriptionUI(variant, forceShow = false) {
    debug('Updating subscription UI for variant:', variant);
    debug('Force show:', forceShow);
    debug('Current subscription mode:', this.isSubscriptionMode);
    
    if (!variant?.selling_plan_allocations?.length) {
      debug('No selling plan allocations found');
      return;
    }

    // Update subscription prices and options
    const allocations = variant.selling_plan_allocations;
    debug('Processing selling plan allocations:', allocations);

    // Show/hide intervals based on subscription mode
    if (this.intervalsContainer) {
      if (forceShow || this.isSubscriptionMode) {
        debug('Showing intervals container');
        this.intervalsContainer.classList.remove('tw-hidden');
        
        // Try to maintain the selected interval, fall back to first if not available
        if (this.selectedIntervalWeeks) {
          const allocation = this.findAllocationByWeeks(allocations, this.selectedIntervalWeeks);
          if (allocation) {
            this.selectIntervalByWeeks(this.selectedIntervalWeeks);
          } else {
            const firstAllocation = allocations[0];
            this.selectFirstInterval();
          }
        } else {
          const firstAllocation = allocations[0];
          this.selectFirstInterval();
        }
      } else {
        debug('Hiding intervals container');
        // this.intervalsContainer.classList.add('tw-hidden');
      }
    }
  }

  handleDeliveryOptionChange(radio) {
    debug('Delivery option changed:', radio.value);
    
    if (!this.intervalsContainer) {
      debug('No intervals container found');
      return;
    }

    this.isSubscriptionMode = radio.value === 'subscribe';
    debug('Subscription mode updated:', this.isSubscriptionMode);
    
    // Show/hide intervals container
    if (this.isSubscriptionMode) {
      debug('Showing intervals container');
      this.intervalsContainer.classList.remove('tw-hidden');
      
      // When switching to subscription mode, try to maintain the selected interval
      if (this.selectedIntervalWeeks) {
        debug('Looking for allocation with weeks:', this.selectedIntervalWeeks);
        debug('Available allocations:', this.currentVariant.selling_plan_allocations);
        const allocation = this.findAllocationByWeeks(this.currentVariant.selling_plan_allocations, this.selectedIntervalWeeks);
        debug('Found allocation:', allocation);
        if (allocation) {
          this.updateSubscriptionPricing(allocation);
          this.selectIntervalByWeeks(this.selectedIntervalWeeks);
        } else {
          debug('Using first allocation:', this.currentVariant.selling_plan_allocations[0]);
          const firstAllocation = this.currentVariant.selling_plan_allocations[0];
          this.updateSubscriptionPricing(firstAllocation);
          this.selectFirstInterval();
        }
      } else {
        debug('No selected weeks, using first allocation:', this.currentVariant.selling_plan_allocations[0]);
        const firstAllocation = this.currentVariant.selling_plan_allocations[0];
        this.updateSubscriptionPricing(firstAllocation);
        this.selectFirstInterval();
      }
    } else {
      debug('Hiding intervals container');
      // this.intervalsContainer.classList.add('tw-hidden');
      if (this.subscriptionInput) {
        this.subscriptionInput.value = '';
      }
    }
  }

  handleIntervalSelection(button) {
    if (!button.dataset) {
      debug('No dataset found for button:', button);
      return;
    }
    debug('Interval selected:', button.dataset);
    
    // Store selected interval weeks
    this.selectedIntervalWeeks = button.dataset.weeks;
    
    // Update subscription input with selling plan ID
    if (this.subscriptionInput) {
      this.subscriptionInput.value = button.dataset.planId;
    }

    // Update pricing
    // const price = parseFloat(button.dataset.price);
    // const comparePrice = parseFloat(button.dataset.comparePrice);
    // const subscriptionPrice = parseFloat(button.dataset.subscriptionPrice || price);
    // const subscriptionComparePrice = parseFloat(button.dataset.subscriptionComparePrice || comparePrice);
    // this.updateIntervalPricing(subscriptionPrice, subscriptionComparePrice);
  }

    handleIntervalSelector(select) {

    debug('Interval selected:', select.dataset);
    
    // Store selected interval weeks
    this.selectedIntervalWeeks = select.dataset.weeks;
    
    // Update subscription input with selling plan ID
    if (this.subscriptionInput) {
      this.subscriptionInput.value = select.value;
    }

  }

  updateIntervalPricing(price, comparePrice) {
    debug('Updating interval pricing:', { price, comparePrice });

    // Update subscription price display and data attributes
    if (this.subscriptionPriceDisplayEl) {
      const subscriptionPrice = price;
      const subscriptionComparePrice = comparePrice;
      
      this.subscriptionPriceDisplayEl.textContent = this.formatMoney(subscriptionPrice);
      this.subscriptionPriceDisplayEl.setAttribute('data-price', price);
      this.subscriptionPriceDisplayEl.setAttribute('data-subscription-price', subscriptionPrice);
      this.subscriptionPriceDisplayEl.setAttribute('data-compare-price', subscriptionComparePrice);
    }

    // Update subscription text with percent off
    const percentOff = this.calculatePercentOff(price, comparePrice);
    if (this.subscriptionTextEl) {
      this.subscriptionTextEl.dataset.percentOff = percentOff;
      this.subscriptionTextEl.textContent = `Subscribe & save ${percentOff}%`;
    }
  }

  calculatePercentOff(price, comparePrice) {
    if (!comparePrice || comparePrice <= price) return 0;
    const discount = ((comparePrice - price) / comparePrice) * 100;
    return Math.round(discount);
  }

  formatMoney(cents) {
    const formatter = new Intl.NumberFormat('en-US', {
      style: 'currency',
      currency: 'USD',
      minimumFractionDigits: 2
    });
    return formatter.format(cents / 100);
  }
}

// Initialize all product cards on the page
function initializeProductCards() {
  debug('Initializing product cards');
  try {
    const cards = document.querySelectorAll('[id^="product-card--"]');
    debug('Found product cards:', cards.length);
    
    cards.forEach(card => {
      try {
        debug('Initializing card:', card.id);
        new ProductCard(card);
      } catch (error) {
        console.error(`Failed to initialize product card ${card.id}:`, error);
      }
    });
  } catch (error) {
    console.error('Failed to initialize product cards:', error);
  }
}

// Handle both DOMContentLoaded and dynamic loading scenarios
if (document.readyState === 'loading') {
  debug('Document still loading, waiting for DOMContentLoaded');
  document.addEventListener('DOMContentLoaded', initializeProductCards);
} else {
  debug('Document already loaded, initializing immediately');
  initializeProductCards();
}

// Re-initialize on Shopify section load/select events
document.addEventListener('shopify:section:load', () => {
  debug('Shopify section loaded');
  initializeProductCards();
});

document.addEventListener('shopify:section:select', () => {
  debug('Shopify section selected');
  initializeProductCards();
}); 